import React, { useState, useEffect, useCallback } from 'react';
import { Sun, Moon, Laptop } from 'lucide-react';

const themes = [
    { name: 'light', label: 'Light', icon: <Sun className="h-5 w-5" /> },
    { name: 'dark', label: 'Dark', icon: <Moon className="h-5 w-5" /> },
    { name: 'system', label: 'System', icon: <Laptop className="h-5 w-5" /> },
];

const ThemeSwitcher = () => {
    const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

    const applyTheme = useCallback((themeChoice) => {
        const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        
        if (themeChoice === 'dark' || (themeChoice === 'system' && systemPrefersDark)) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('theme', theme);
        applyTheme(theme);
        
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        
        const handleSystemThemeChange = () => {
            if (localStorage.getItem('theme') === 'system') {
                applyTheme('system');
            }
        };

        mediaQuery.addEventListener('change', handleSystemThemeChange);

        return () => mediaQuery.removeEventListener('change', handleSystemThemeChange);
    }, [theme, applyTheme]);

    return (
        <div className="flex items-center p-1 rounded-lg bg-gray-200 dark:bg-gray-700 space-x-1">
            {themes.map(({ name, label, icon }) => (
                <button
                    key={name}
                    onClick={() => setTheme(name)}
                    className={`p-1.5 rounded-md text-gray-600 dark:text-gray-300 transition-colors ${
                        theme === name 
                        ? 'bg-white dark:bg-gray-800 shadow-sm' 
                        : 'hover:bg-white/50 dark:hover:bg-black/20'
                    }`}
                    aria-label={`Switch to ${label} theme`}
                >
                    {icon}
                </button>
            ))}
        </div>
    );
};

export default ThemeSwitcher;
